import { Loading } from 'element-ui';
export default {
  data() {
    return {
      showBtn:[//根据用户权限，判断用户是否有该功能，没有则隐藏其对应按钮
        {isShow:false,id:'search'},
        {isShow:false,id:'modify'},
        {isShow:false,id:'delete'},
        {isShow:false,id:'create'},
        {isShow:false,id:'import'},
        {isShow:false,id:'export'},
      ],
      //分页数据
      paging_data:{
        currentPage:1,
        pageSize:50,
        total:0,
      },
      //地区数据
      area_data:{
        province:[],
        city:[],
        county:[],
        town:[],
        village:[],
      },
      province:'',
      city:'',
      county:'',
      town:'',
      village:'',
      editForm:{
        phone:'',
      },
      arrPlace:[],
      arrPlace1:[],
      arrPlace2:[],
      form:{},
      form1:{},
      dis:[],
      lodaingTime:false,
      admin:false,
      comAdmin:false,
      subAdmin:false,
      downShow:false
    }
  },
  created() {
    this.getDefault()
    let res = JSON.parse(window.localStorage.getItem('loginData'))
    this.admin = res.admin
    this.comAdmin = res.comAdmin
    this.subAdmin = res.subAdmin
  },
  methods: {
    /** 弹框
     * @param content   提示内容
     * @param title   提示标题
     * @param confirm   确认操作按钮
     * @param cancel   却笑按钮
     * @param _tipsType 类型
     * @param center  是否集中
     * @param callback  点击取消按钮回调
     * @param showClose 是否显示关闭按钮
     */
    open: function ({
              content = '是否执行当前操作',
              title = '提示',
              confirm = '确认',
              cancel = '取消',
              _tipsType = '',
              center = true,
              showClose = false,
              callback = () => {},
            } = {}) {
      this.$confirm(content, title, {
        confirmButtonText: confirm,
        cancelButtonText: cancel,
        type: _tipsType,
        showClose:showClose,
        center: center
      }).then( () => callback(true)).catch(() => callback(false));
    },

    /** 消息提示
     * @param message  提示信息
     * @param type  提示类型
     * @param center   文字睡否剧中
     * @param showClose  是否课关闭
     * @private
     */
    _tips({
          message,
          type = 'success',
          center = false,
          showClose = false
        }) {
      this.$message({
        showClose: showClose,
        message: message,
        type: type,
        center: center
      });
    },

    /** 加载
     * @param text 提示内容
     * @param _function_Expression 在加载过程中要执行的函数表达式
     * @param time 显示遮罩层时间
     */
    openFullScreen({text,_function_Expression = () => false,time = 1000} = {}) {
      let [vm = this] = []
      const loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        _function_Expression()
      }, time);
    },

    // 文件筛选
    Filter_file({ api, data, callback=() => {} } = {}) {
      Object.getOwnPropertyNames(data).forEach(function(key) {
        data[key] === '' || data[key] === undefined ? delete data[key] : ''
      })
      // data.pageSize = 5
      let rD = {areaNames:[]}
      let area = [this.province,this.city,this.county,this.town,this.village]
      //过滤空字符串
      rD.areaNames = area.filter(x => x)
      this.$api.changePlace(rD).then(res =>{
        if (res.data.status === 0) {
          let areaData = JSON.parse(res.data.data)
          let areaId = areaData[areaData.length - 1]
          if (areaId) {
            if (typeof data === 'object') {
              console.log(data)
              this.$api.getData(api, data).then(res => {
                if (res.data.status === 0) {
                  let _R = JSON.parse(res.data.data)
                  
                  callback(_R)
                  if (JSON.parse(res.data.data).length === 0) {
                    this.$message.warning('无相关信息')
                  }
                  this.paging_data.total = res.data.size
                  this.paging_data.pageSize = res.data.pageSize
                } else if (res.data.status === 10) {
                  return this.$message.warning('无相关信息')
                } else {
                  return this.$message.warning('查询失败')
                }
              })
            } else this.$message.warning('筛选参数必须为对象')
          } else { this.$message.warning('请至少输入一个地区') }
        } else { this._status(res.data) }
      })
    },

    // 文件删除
    Delete_files(url,data) {
      let [vm] = [this]
      let _d = () => {
        vm.$api.delete_files({url:url,data:data}).then(r => r.data.status === 0 ?
          vm._tips({message:'删除成功'}) : vm._tips({message:'删除失败',type:'error'}) )
      }
      vm.open({content:'是否删除当前文件',callback:e => e === true ? _d() : ''})
    },
    // 获取地理位置
    getArea(data) {
      let [vm] = [this]
      vm.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          vm.village = ''
          switch(data.key) {
            case 0 :
              vm.area_data.province = _R
              break
            case 1 :
              vm.area_data.city = _R;
              vm.province = data.name;
              vm.city = ''
              vm.county = ''
              vm.town = ''
              // vm.village = ''
              break
            case 2 :
              vm.area_data.county = _R;
              vm.city = data.name; 
              vm.county = ''
              vm.town = ''
              // vm.village = ''
              break
            case 3 :
              vm.area_data.town = _R;
              vm.county = data.name; 
              vm.town = ''
              // vm.village = ''
              break
            case 4 :
              vm.area_data.village = _R;
              vm.town = data.name; 
              // vm.village = ''
              break
            case 5 :
              vm.village = data.name; 
              break
            default : break
          }
        } else {
          vm.$message.error('获取失败')
        }
        // n < 5 ? this.getArea({value:{areaId:vm.arrPlace[n]},key:(n+1),name:arr[n]},++n,arr) : ''
        // console.log(this.province,this.city,this.county,this.town,this.village)
      })
    },
    getArea2(data) {
      let [vm] = [this]
      vm.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : vm.area_data.province = _R; break;
            case 1 : vm.area_data.city = _R; vm.province = data.name; break;
            case 2 : vm.area_data.county = _R; vm.city = data.name;  break;
            case 3 : vm.area_data.town = _R; vm.county = data.name;  break;
            case 4 : vm.area_data.village = _R; vm.town = data.name;  break;
            case 5 : vm.village = data.name;  break;
            default : break
          }
        } else { vm.$message.error('获取失败') }
        // console.log(this.province,this.city,this.county,this.town,this.village)
      })
    },
    // 自定义事件获取位置
    getPlace(data) { this.getArea(data) },
    // 自定义事件获取位置(搜索) 存储搜索条件的地址name到form，解决修改弹框与搜索列的组件冲突
    getPlace1(data) {
      switch(data.key) {
        case 1 : this.form.province= data.name;break;
        case 2 : this.form.city= data.name;break;
        case 3 : this.form.county= data.name;break;
        case 4 : this.form.town= data.name;break;
        case 5 : this.form.village= data.name;break;
        default : break;
      }
      this.getArea(data)
    },
    // 自定义事件获取位置(搜索) 存储搜索条件的地址name到form，解决修改弹框与搜索列的组件冲突 导出表事件
    getPlace2(data) {
      switch(data.key) {
        case 1 : this.form1.province= data.name;break;
        case 2 : this.form1.city= data.name;break;
        case 3 : this.form1.county= data.name;break;
        case 4 : this.form1.town= data.name;break;
        case 5 : this.form1.village= data.name;break;
        default : break;
      }
      this.getArea(data)
    },
    // 用地址名查对应id，返回id用来查下拉框数据
    setPlace(data,str) {
      let vm = this
      let newData = {areaNames:[]}
      newData = { areaNames: [ data.province, data.city, data.county, data.town, data.village ] }
      // console.log(newData.areaNames)
      vm.$api.changePlace(newData).then(res =>{
        if (res.data.status === 0) {
          if (str === 'search') {
            vm.arrPlace1 = JSON.parse(res.data.data)
            vm.arrPlace1.forEach((areaId,i) => { vm.getArea2({ value: { areaId }, key: (i + 1), name: newData.areaNames[i] }) })
          } else {
            vm.arrPlace = JSON.parse(res.data.data)
            // console.log(vm.arrPlace)
            // console.log(data)
            let areaArr = []
            areaArr[0] = data.province
            areaArr[1] = data.city
            areaArr[2] = data.county
            areaArr[3] = data.town
            areaArr[4] = data.village
            vm.arrPlace.forEach((x,i) => { 
              vm.getArea2({value:{areaId:x},key:(i+1),name:areaArr[i]})
            })
          }
        } else {
          this._status(res.data)
        }
      })
    },
    // 控制模块的操作按钮是否显示
    isShowBtn(str) {
      this.showBtn.forEach(x => {//所有按钮显示重置为false
        x.isShow = false
      })
      this.loginData = JSON.parse(window.localStorage.getItem('loginData'))
      if (this.loginData.admin) {//管理员
        this.showBtn.forEach(x => {
          x.isShow = true
        })
      } else {
        let privilegesList = JSON.parse(window.localStorage.getItem('loginData')).privilegesList
        this.showBtn.forEach(x => {
          if (privilegesList.includes(str+'-'+x.id)) {
            x.isShow = true
          }
        })
      }
      console.log(this.showBtn)
    },
    //打开弹框
    openBox(str) {
      // console.log(this.province,this.city,this.county)
      // this.clearPlace()
      this.editForm = {}
      if (this.$route.name == 'Form_grxxcj') {
        // this.loginData.personal ? this.editForm.phone = this.loginData.name : ''
      } else if (this.$route.name == 'form_gwxxgxqkb') {
        this.loginData.organization ? this.editForm.organizationName = this.loginData.o_name : ''
      }
      if (str === 'edit') {
        this.isCreate = false
        this.editForm = this.selectRow[0]
        // console.log(this.editForm)
        if (this.$route.name == 'Form_grxxcj') {
          // this.loginData.personal ? this.$set(this.editForm,'auditStatus','已核实') : ''
        }
        console.log(this.editForm)
        this.setPlace(this.editForm)
        this.centerDialogVisible = true            
      } else {
        this.isCreate = true
        this.imageUrl1 = ''
        // this.arrPlace = []
        JSON.parse(window.localStorage.getItem('loginData')).admin===true ? this.arrPlace = [] : this.setPlace(this.form)
        this.centerDialogVisible = true
      }
      
    },
    //删除数据
    deleteDate(str) {
      // console.log(this.province,this.city,this.county)
      // this.clearPlace()
      this.selectRow.length === 0
        ? this.$message.error('请至少勾选一条数据')
        : this.$confirm('确定删除数据?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
          let ids = this.selectRow.map(i => i.id)
          // console.log(ids)
          let api = ''
          switch (str) {
            case 'gwsbbttjb': api += '/user/socialAllowance'; break; // √
            case 'axdw': api += '/user/loveUnit'; break; // √
            case 'ycxqzcybttbj': api += '/user/onceSetupAllowance'; break; // √
            case 'gyxgwaztjb': api += '/user/publicWelfareJob'; break; // √
            case 'gwxxgxqkb': api += '/user/jobUpdate'; break; // √
            case 'jyfpjd': api += '/user/employmentBase'; break; // √
            case 'gwcctjb': api += '/user/jobCheck'; break; // √
            case 'rycctjb': api += '/user/personCheck'; break; // √
            case 'pkhxx': api += '/user/poorInfo'; break; // √
						case 'fp': api += '/user/poorLabor'; break; // √
						case 'jyfpcjtjb': api += '/user/helpPoorWorkshop'; break; // √
						case 'dlgkbb': api += '/user/mineOrg'; break; // √
						case 'tyjryb': api += '/user/retireSoldier'; break; // √
						case 'jycyfwbt_rlzyfwjgbtsb': api += '/user/pioneerJobAllowance'; break; // √
						case 'jycyfwbt_rlzyfwjg': api += '/user/resourceOrganization'; break; // √
						case 'jycyfwbt_nclwjjr': api += '/user/villageAgent'; break; // √
						case 'jycyfwbt_nclwjjrbtsb': api += '/user/villageAgentApplyAllowance'; break; // √
						case 'ygdxbttjb': api += '/user/trainingWorkAllowance'; break; // √
						case 'czdjsyrytjb': api += '/user/lostJobPerson'; break; // √
						case 'jtbttjb': api += '/user/trafficAllowance'; break; // √
						case 'pxbthshfbt': api += '/user/trainingAllowance'; break; // √
						
						case 'mbrwtjb': api += '/user/targetTask'; break; // √

						case 'ncldlzyjyhcyb': api += '/user/transferJob'; break; // √
						case 'gyxjdbfzb': api += '/user/helpCP'; break; // √
						case 'gyxrlzysczytjzbb': api += '/user/resourceMarket'; break; // √

						case 'dwzp': api += '/user/recruitUnit'; break; // √

						// 博白县
						case 'cj_jyfpcjdtgltz': api += '/user/bobaiHelpPoorManage'; break;
						case 'cj_jyfpcjjbqkhzb': api += '/user/bobaiHelpPoorWorkShop'; break; // 就业扶贫车间
						case 'cj_jyfpcjxnjymchzb': api += '/user/bobaiPoorlabor'; break; // 名册汇总
						case 'cj_xnpkldljydtjgtz': api += '/user/bobaiPoorRecord'; break; // 就业扶贫车间吸纳建档立卡贫困家庭劳动力就业情况动态监管台账
						case 'cj_xnydbqpkldljymc': api += '/user/bobaiTransfer'; break; // 就业扶贫车间吸纳建档立卡贫困家庭劳动力就业花名册(易地扶贫搬迁)
					}
					// console.log(api)
					this.$api.deleteData(this.$api.imgUrl+api, ids).then(res => {
            if (res.data.status == 0) {
              console.log(res)
              this.$message.success('删除成功!')
              this.Filter_file({api:this.api,data:this.form,callback:_d => this.tableData = _d })
            } else {
              this._status(res.data)
            }
					})
				}).catch(() => {})
			},
    //关闭弹框回调
    close() {
      this.clearPlace()
      //清空日志
      this.logType = 1,
      this.logImg = [],
      this.serviceContent = '',
      this.serviceResult = '',
      this.activeName = '结对帮扶',
      this.isCreate = false ? 
      this.$refs.uploadImg.forEach(x => {
        x.clearFiles()
      }):'';
      // console.log(this.form)
      // console.log(this.form1)
      //恢复筛选得地址
      this.setPlace(this.form,'search')
      this.setPlace(this.form1,'search')
    },
    //图片上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      // console.log(this.imageUrl);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
			if (!isJPG) { this.$message.error('上传图片只能是 JPG 格式!') }
			if (!isLt2M) { this.$message.error('上传图片大小不能超过 2MB!') }
			return isJPG && isLt2M
    },
    /** 文件导出
     * @param data 筛选参数
     * @param callback 筛选成功回调函数
     * @param api 筛选地址
     * @constructor
     */
    Filter_export(api,data) {
      let vm = this
      let areaName = {areaNames:[]}
      let area = [vm.province,vm.city,vm.county,vm.town,vm.village]
      //过滤空字符串
      areaName.areaNames = area.filter(o => o)
      vm.$api.changePlace(areaName).then(res =>{
        if (res.data.status === 0) {
          let areaData = JSON.parse(res.data.data)
          data.areaId = areaData[areaData.length-1]
          if (data.areaId === undefined) {
            return vm.$message.info('请至少输入一个地区')
          } else {
            let loadingInstance = Loading.service({
              lock: true,
              text: '导出中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
              fullscreen: true 
            })
            vm.$api.getExport(api,data).then(res =>{
              if (res.data.status === 0) {
                this.$nextTick(() => { loadingInstance.close() }) // 以服务的方式调用的 Loading 需要异步关闭
                vm.$api.download_doc(res.data.data)
              } else {
                this._status(res.data)
              }
            })
          }
        } else {
          this._status(res.data)
        }
      })
    },
    
    //设置默认地址
    getDefault() {
      let vm = this
      let data = JSON.parse(window.localStorage.getItem('loginData'))
      if (data.admin) {
        for (let index = 0; index < 5; index++) { vm.dis.push(false) }
      } else {
        vm.$api.getFather({areaId:data.areaId}).then(res => {
          if (res.data.status === 0) {
            // console.log(res.data.data)
            let _R = JSON.parse(res.data.data)
            _R.forEach((x,i) => {
              this.arrPlace[x.level] = x.name
              this.arrPlace1[x.level] = x.name
              this.arrPlace2[x.level] = x.name
              // vm.arrPlace.push(x.name)
              // vm.arrPlace1.push(x.name)
              // vm.arrPlace2.push(x.name)
              i === 4 ? vm.dis.push(false) : vm.dis.push(true)
              switch(x.level) {
                case 0 : vm.form.province= x.name;break;
                case 1 : vm.form.city= x.name;break;
                case 2 : vm.form.county= x.name;break;
                case 3 : vm.form.town= x.name;break;
                case 4 : vm.form.village= x.name;break;
                default : break;
              }
            })
            vm.setPlace(vm.form,'search')
          } else {
            this._status(res.data)
          }
        })
      }
    },
    //置空遗留地址
    clearPlace() {
      this.province = ''
      this.city = ''
      this.county = ''
      this.town = ''
      this.village = ''
    },
    //跳转
    jump(componentName,data) {
      this.openedTab = this.$store.state.openedTab
      // tabNum 为当前点击的列表项在openedTab中的index，若不存在则为-1
      let tabNum = this.openedTab.indexOf(componentName)
      if (tabNum === -1) {
        // 该标签当前没有打开
        // 将componentName加入到已打开标签页state.openedTab数组中
        this.$store.commit('addTab', componentName)
      } else {
        // 该标签是已经打开过的，需要激活此标签页
        this.$store.commit('changeTab', componentName)
      }
      this.$router.push({ name: 'Form_grxxcj', params: { info:data } })
    },
    //关闭下载模板弹窗
    cutOff(bool) {
      this.downShow = bool
    }
  },
  // beforeRouterEnter:(to,from,next)=>{
  //  	next(vm =>{ vm.downShow = false })
  // }
}